/* src/app/modules/invoice/invoice-tabs.component.scss */
/*# sourceMappingURL=invoice-tabs.component.css.map */
